import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  IonMenu,
  IonMenuToggle,
  IonButton,
  IonList,
  IonItem,
  IonIcon,
  MenuController
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { homeOutline } from 'ionicons/icons';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  imports: [IonMenu, IonButton, IonList, IonItem, IonIcon, IonMenuToggle],
})
export class MenuComponent  implements OnInit {
  isSelectorOpen: boolean = false;

  constructor(
    private router: Router,
    private menuCtrl: MenuController
  ) {
    addIcons({
      homeOutline,
    });
  }

  ngOnInit() {}

  navToStore() {
    this.router.navigate(['/tienda'], {
      // replaceUrl: true
    });
    this.menuCtrl.close();
  }

  navToPurchaseHistory() {
    this.router.navigate(['/historial-compras'], {
      // replaceUrl: true
    });
    this.menuCtrl.close();
  }

  navToShoppingCart() {
    this.router.navigate(['/carrito'], {
      // replaceUrl: true
    });
    this.menuCtrl.close();
  }

  navToHome() {
    this.router.navigate(['/dashboard'], {
      // replaceUrl: true
    });
    this.menuCtrl.close();
  }

  toggleDropdown() {
    this.isSelectorOpen = !this.isSelectorOpen;
  }

  goToWhatsapp() {
    const phoneNumber = '56934047167';
    const message = '¡Hola Clínica Belenus! Necesito ayuda';
    const url = `https://wa.me/${phoneNumber}/?text=${message}`;
    window.open(url, '_blank');
  }

  goToCallCenter() {
    const url = 'tel:+56232102550';
    window.open(url, '_blank');
  }
}
